import { Chip, type ChipSize } from '@/components/ui'
import type { FormulationStatus } from '../api/types'

/**
 * Module-scoped status chip for formulations (Sprint 08b).
 *
 * Maps the state-machine values to the existing Chip primitive's
 * tones — single source of truth for "what color is approved" so
 * the list row and the detail header stay aligned. Module-scoped
 * because nothing outside Formulations consumes this mapping today.
 */

const VARIANT_BY_STATUS: Record<
  FormulationStatus,
  'neutral' | 'info' | 'success' | 'danger'
> = {
  draft: 'neutral',
  testing: 'info',
  approved: 'success',
  rejected: 'danger',
}

const LABEL_BY_STATUS: Record<FormulationStatus, string> = {
  draft: 'Draft',
  testing: 'Testing',
  approved: 'Approved',
  rejected: 'Rejected',
}

export interface StatusChipProps {
  status: FormulationStatus
  size?: ChipSize
}

export function StatusChip({ status, size = 'xs' }: StatusChipProps) {
  return (
    <Chip variant={VARIANT_BY_STATUS[status]} size={size} dot>
      {LABEL_BY_STATUS[status]}
    </Chip>
  )
}
